export const normalizeWorkspacePart = (value) => String(value ?? "").toUpperCase();

export const composeWorkspaceName = (teamCode, clientName) => (
  [teamCode, clientName]
    .map(normalizeWorkspacePart)
    .map((part) => part.trim())
    .filter(Boolean)
    .join(" - ")
);

export const splitWorkspaceName = (name) => {
  const parts = String(name ?? "").split(" - ");
  if (parts.length === 1) {
    return { teamCode: normalizeWorkspacePart(name).trim(), clientName: "" };
  }
  return {
    teamCode: normalizeWorkspacePart(parts.shift()).trim(),
    clientName: normalizeWorkspacePart(parts.join(" - ")).trim(),
  };
};